export const fleetplan = [
  {
    fleetid: 1,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
  {
    fleetid: 2,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
  {
    fleetid: 3,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
  {
    fleetid: 4,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
  {
    fleetid: 5,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
  {
    fleetid: 6,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
  {
    fleetid: 7,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
  {
    fleetid: 8,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
  {
    fleetid: 9,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
  {
    fleetid: 10,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
  {
    fleetid: 11,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
  {
    fleetid: 12,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
  {
    fleetid: 13,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
  {
    fleetid: 14,
    days: [
      {
        day: 1,
        role: 'Departure',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
        ],
      },
      {
        day: 2,
        role: 'Adventure Begins',
        description:
          'Arrive Cairo airport, welcome greeting by our representative who will assist you and provide transfers to your Hotel in Cairo. (the clients will inform us about their arrival time minimum 7 days before the',
        activities: [
          'Admire Big Ben, Buckingham Palace and St Paul’s Cathedral',
          'Chance to spot prominent landmarks of the city',
          'welcome greeting by our representative',
        ],
      },
      {
        day: 3,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
      {
        day: 4,
        role: 'Historical Tour',
        description:
          "Please go to the London Eye ticket office to exchange your voucher for a ticket. You may be asked for identification (driver's license, national identity card, or passport). You will receive tickets for the next available time slot, but you may request a different date or time, subject to availability. The following items are not permitted: alcohol, baseball bats, bicycles (including folding ones), explosives. For all ticket holders, the number of people per capsule may vary.",
        activities: null,
      },
      {
        day: 5,
        role: 'Historical Tour',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        activities: null,
      },
    ],
  },
]
